import { PushNotificationProvider } from "@/models";
import appInsights from "@/utils/appInsights";
import { NativeAppType } from "./";
import { BaseNativeApp, CallNative, WebToNativeMethodParameter, WebToNativeMethods } from "./baseNativeApp";

// Tell Typescript about the webkit property the iOS app puts on window
declare global {
  interface Window {
    webkit?: Webkit;
  }
}

export interface Webkit {
  messageHandlers: {
    [Key in keyof WebToNativeMethods]: WebkitMessageHandler<WebToNativeMethodParameter<Key>>;
  };
}

export interface WebkitMessageHandler<T> {
  postMessage(params: T): void;
}

export function isIOS() {
  return !!window.webkit?.messageHandlers;
}

// This represents the communication from Vue to the iOS app
export default class IOS extends BaseNativeApp {
  readonly isMobile = true;
  readonly type = NativeAppType.iOS;
  readonly deviceOS = "iOS";
  readonly pushNotificationProvider = PushNotificationProvider.Apple;

  readonly callNative: CallNative = (method, param) => {
    // appInsights.trackEvent({
    //   name: "Web -> NativeApp: " + method,
    //   properties: {
    //     type: this.deviceOS
    //   }
    // });

    // Need to cast to any here because typescript wasn't able to convert this to the correct type
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.webkit?.messageHandlers[method]?.postMessage(param as any);
  };
}
